import { headers } from './constants';
import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';
import { initiateOIDCResponse } from './oidcClient';
import Identity from './identity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';

/**
 *
 * When used as a response to a user action (onclick) event, this function will prompt the user to login to an OIDC if they have not already done so.
 * Initiates a sign-in session on Arc XP's side which lasts 10 minutes. The response contains all the components required in order to redirect the user to the IDP's authorization screen.
 *
 * @param oidcClientId The OAuth client ID assigned by your IDP and configured with Arc XP
 * @param redirect Flag by default to true. If this flag is set go false, a response containing all the components required in order to redirect the user to the IDP's authorization screen will be returned. Otherwise the user will be automatically redirected to the login url defined for the OIDC client
 * @param scopes scopes used by the OIDC provider
 *
 *  * @returns
 * A __Promise__. When successful, if avoidRedirect is undefined or false the user is redirected to the OIDC client login page.
 *
 */

export const initiateOIDC = async (
  oidcClientId: string,
  scopes?: [string],
  redirect: boolean = true,
  isApple: boolean = false
): Promise<APIErrorResponse | initiateOIDCResponse | void> => {
  return fetch(`${Identity.apiOrigin}/identity/public/v2/oidc/${oidcClientId}/initiate`, {
    method: 'GET',
    headers: {
      ...headers
    }
  })
    .then(JSONResponseHandler)
    .then(json => {
      if (isAPIErrorResponse(json)) {
        throw json;
      } else {
        if (redirect) {
          if (scopes && scopes.length) {
            let url = new URL(json.url);
            url.searchParams.set('scope', scopes.join(' '));

            if (isApple) {
              url.searchParams.set('response_mode', 'form_post');
            }

            window.location.href = url.toString();
          } else {
            window.location.href = json.url;
          }
        } else {
          return json;
        }
      }
    });
};

export default initiateOIDC;
